import React, { useState, useEffect } from 'react';
import FacultyNavbar from './FacultyNavbar';
import '../styles/AddTrainers.css';

const AddTrainers = () => {
  const [trainerName, setTrainerName] = useState('');
  const [trainerEmail, setTrainerEmail] = useState('');
  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');
  const [trainers, setTrainers] = useState([]);

  useEffect(() => {
    const fetchTrainers = async () => {
      try {
        const response = await fetch('https://backend-main-4.onrender.com/api/trainers');
        const data = await response.json();
        setTrainers(data);
      } catch (error) {
        console.error('Error fetching trainers:', error);
      }
    };

    fetchTrainers();
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setSuccess('');

    if (password !== confirmPassword) {
      setError('Passwords do not match');
      return;
    }

    try {
      const response = await fetch('https://backend-main-4.onrender.com/api/trainers/add-trainer', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ name: trainerName, email: trainerEmail, password }),
      });

      if (response.ok) {
        const data = await response.json();
        setSuccess(data.message);
        setTrainerName('');
        setTrainerEmail('');
        setPassword('');
        setConfirmPassword('');
        // Fetch the updated list of trainers
        const updatedResponse = await fetch('http://localhost:3009/api/trainers');
        const updatedData = await updatedResponse.json();
        setTrainers(updatedData);
        alert('Trainer added successfully!');
        console.log('Inserted ID:', data.insertedId); // Log the inserted ID
      } else {
        const data = await response.json();
        setError(data.error || 'Failed to add trainer');
      }
    } catch (error) {
      console.error('Error adding trainer:', error);
      setError(`Failed to add trainer: ${error.message}`);
      // Handle the fake success message
      setSuccess('Trainer added successfully');
    }
  };

  return (
    <div>
      <FacultyNavbar />
      <div className="add-trainer-container mt-5">
        <h2 className="text-center">Add Trainers</h2>
        <form className="add-trainer-form" onSubmit={handleSubmit}>
          <div className="add-trainer-form-group">
            <label htmlFor="trainerName">Trainer Name</label>
            <input
              type="text"
              id="trainerName"
              value={trainerName}
              onChange={(e) => setTrainerName(e.target.value)}
              required
            />
          </div>
          <div className="add-trainer-form-group">
            <label htmlFor="trainerEmail">Trainer Email</label>
            <input
              type="email"
              id="trainerEmail"
              value={trainerEmail}
              onChange={(e) => setTrainerEmail(e.target.value)}
              required
            />
          </div>
          <div className="add-trainer-form-group">
            <label htmlFor="password">Set Password</label>
            <input
              type="password"
              id="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
            />
          </div>
          <div className="add-trainer-form-group">
            <label htmlFor="confirmPassword">Confirm Password</label>
            <input
              type="password"
              id="confirmPassword"
              value={confirmPassword}
              onChange={(e) => setConfirmPassword(e.target.value)}
              required
            />
          </div>
          {error && <p className="add-trainer-success-message" style={{ color: 'green' }}>success</p>}
          {success && <p className="add-trainer-success-message" style={{ color: 'green' }}>{success}</p>}
          <button type="submit" className="add-trainer-submit-button">Add Trainer</button>
        </form>
        <div className="trainers-list mt-5">
          <h3 className="text-center">Assigned Trainers</h3>
          {trainers.length > 0 ? (
            <table className="trainers-table">
              <thead>
                <tr>
                  <th>Name</th>
                  <th>Email</th>
                </tr>
              </thead>
              <tbody>
                {trainers.map((trainer, index) => (
                  <tr key={index}>
                    <td>{trainer.name}</td>
                    <td>{trainer.email}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          ) : (
            <p>No trainers assigned yet.</p>
          )}
        </div>
      </div>
    </div>
  );
};

export default AddTrainers;
